import { Button } from "@/components/ui/button";
import { useCopyToClipboard } from "@/hooks/useCopyToClipboard";
import { cn } from "@/lib/utils";
import { Icon } from "@iconify/react";

interface CopyButtonProps {
  value: string;
  className?: string;
}

export function CopyButton({ value, className }: CopyButtonProps) {
  const { isCopied, copyToClipboard } = useCopyToClipboard();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => copyToClipboard(value)}
      className={cn("h-8 w-8", className)}
      title={isCopied ? "Copied!" : "Copy to clipboard"}
      aria-live="polite"
      aria-label={isCopied ? "Copied to clipboard" : "Copy to clipboard"}
    >
      <Icon
        icon={isCopied ? "lucide:check" : "lucide:copy"}
        className="h-4 w-4"
      />
    </Button>
  );
}
